export default "__VITE_ASSET__CXHFng4M__"